// change only colors

const generateCustomStyles = (customStyles: any) => {
  const {
    viewMode,
    widgetContainer,
    welcomeFormContainer,
    welcomeFormTitle,
    welcomeFormItem,
    welcomeFormInputLabel,
    welcomeFormInputField,
    welcomeFormSubmitButton,

    /** */
    chatbotContainer,
    chatbotInnerContainer,
    chatbotHeader,
    chatMessagesContainer,
    chatMessageContainer,
    chatUserMessageContainer,
    chatBotMessageContainer,

    chatMessageTitle,
    chatBotMessageTitle,
    chatUserMessageTitle,

    chatMessageText,
    chatBotMessageText,
    chatUserMessageText,
    
    chatUserInputContainer,
    chatUserInputField,
    chatUserInputPlaceholder,
    chatUserInputFieldFocused,
    chatSendButton,
    chatSendButtonIcon,

    chatFormContainer,
    chatFormLabel,

    chatFormSelect,
    chatFormInputField,
    chatFormInputFieldFocused,
    
    chatFormRadioButtonsBlock,
    chatFormRadioButtonLabel,
    chatFormRadioButton,
    chatFormRadioButtonSelected,

    selectButton,

    chatFormSubmitButton,
    chatFormSubmitButtonDisabled
  } = customStyles;

  return `
    .widget {
      width: ${widgetContainer?.width || "inherit"};
      height: ${widgetContainer?.height || "inherit"};
      max-width: ${widgetContainer?.maxWidth || "800px"};
      max-height: ${widgetContainer?.maxHeight || "600px"};
    }

    /* FIRST STEP */
    .step.step-0 {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      max-width: ${welcomeFormContainer?.maxWidth || "540px"};
      height: auto;
      padding: 16px;
      background-color: ${welcomeFormContainer?.backgroundColor || "transparent"};
    }

    .step-0 .step-title {
      color: ${welcomeFormTitle?.color || "rgba(96, 96, 96, 1)"};
      font-weight: ${welcomeFormTitle?.fontWeight || "700"};
      font-size: ${welcomeFormTitle?.fontSize || "26px"};
      line-height: ${welcomeFormTitle?.lineHeight || "31px"};
      text-align: center;
      margin-bottom: ${welcomeFormTitle?.marginBottom || "50px"};
    }

    .step.step-0 form {
      width: 100%;
      margin: 0;
    }

    .step.step-0 form label {
      width: 100%;
      margin-bottom: ${welcomeFormItem?.marginBottom || "36px"};
      display: flex;
      justify-content: center;
    }

    .step.step-0 form .label {
      width: 100%;
      font-size: 14px${welcomeFormInputLabel?.color || ""};
      padding-bottom: 6px;
      color: ${welcomeFormInputLabel?.color || ""};
    }

     .step-0 .input-field {
      border: 1px solid ${welcomeFormInputField?.borderColor || "#e5e7eb"};
      border-radius: ${welcomeFormInputField?.borderRadius || "6px"};
      height: ${welcomeFormInputField?.height || "60px"};
      width: ${welcomeFormInputField?.width || "283px"};
      padding: ${welcomeFormInputField?.padding || "6px"};
      box-shadow: ${welcomeFormInputField?.boxShadow || "none"};
      font-size: ${welcomeFormInputField?.fontSize || "16px"};
      font-weight: ${welcomeFormInputField?.fontWeight || "40"};
      color: ${welcomeFormInputField?.color || "#000000"};
    }

    .step.step-0 .form-buttons {
      display: flex;
      justify-content: center;
    }

    .step.step-0 form button {
      height: ${welcomeFormSubmitButton?.height || "46px"};
      width: ${welcomeFormSubmitButton?.width || "114px"};
      background-color: ${welcomeFormSubmitButton?.backgroundColor || "rgba(156, 39, 176, 1)"};
      border: 1px solid ${welcomeFormSubmitButton?.borderColor || "rgba(156, 39, 176, 1)"};
      border-radius: ${welcomeFormSubmitButton?.borderRadius || "3px"};
      color: ${welcomeFormSubmitButton?.color || "#FFFFFF"};
      padding: 6px;

      font-size: ${welcomeFormSubmitButton?.fontSize || "26px"};
      font-weight: ${welcomeFormSubmitButton?.fontWeight || "bold"};
      line-height: 46px;
      margin-top: ${welcomeFormSubmitButton?.marginTop || "-18px"};
    }

    /*  */

    .step-1>div {
      height: 100%;
      width: 100%;
    }
    .react-chatbot-kit-chat-inner-container {
      display: flex;
      flex-direction: column;
      height: 100% !important;
      border-radius: ${chatbotInnerContainer?.borderRadius|| "5px"};
      background-color: ${chatbotInnerContainer?.backgroundColor|| "transparent"};
      overflow: hidden;
      border: ${chatbotInnerContainer?.border|| "none"};
      padding: ${chatbotInnerContainer?.padding|| "inherit"};
    }

    .react-chatbot-kit-chat-header {
      display: flex;
      justify-content: center;
      text-align: center;
      background-color: ${chatbotHeader?.backgroundColor|| "#F5F5F5"};
      border-bottom: ${chatbotHeader?.borderBottom|| "none"};
      border-radius: 0px;
      color: ${chatbotHeader?.color|| "#7A4C82"};
      font-size: ${chatbotHeader?.fontSize|| "18px"};
      font-weight: ${chatbotHeader?.fontWeight|| "300"};
      font-family: ${chatbotHeader?.fontStyle|| "inherit"};
      padding: ${chatbotHeader?.padding || "12.5px"};
      line-height: ${chatbotHeader?.lineHeight || "inherit"};
    }

    .react-chatbot-kit-chat-message-container {
      background: ${chatMessagesContainer?.backgroundColor || '#F5F5F5'};
      padding: ${chatMessagesContainer?.padding || '0 16px'};
      height: ${chatMessagesContainer?.height || '424px'};
      overflow-y: auto; 
      overflow-x: hidden;
    }

    /*  */

    .react-chatbot-kit-chat-bot-form-container .inner,
    .react-chatbot-kit-chat-bot-message-container .inner,
    .react-chatbot-kit-user-chat-message-container .inner {
      position: relative;
      width: 48%;
      max-width: 48%;
      padding: ${chatMessageContainer?.padding || "8px"};
      box-shadow: ${chatMessageContainer?.boxShadow || "none"};
    }

    .react-chatbot-kit-chat-bot-form-container .inner,
    .react-chatbot-kit-chat-bot-message-container .inner {
      background-color: ${chatBotMessageContainer?.backgroundColor || "#FFFFFF"};
      border-radius: ${chatBotMessageContainer?.borderRadius || "12px"};
      padding: ${chatBotMessageContainer?.padding || chatMessageContainer?.padding || "8px"};
    }

    .react-chatbot-kit-chat-bot-form-container .quote-tail,
    .react-chatbot-kit-chat-bot-message-container .quote-tail {
      width: ${chatBotMessageContainer?.borderRadius};
      background-color: ${chatBotMessageContainer?.backgroundColor || "#FFFFFF"};
    }

    .react-chatbot-kit-chat-bot-form-container .quote-tail > div,
    .react-chatbot-kit-chat-bot-message-container .quote-tail > div {
      width: ${chatBotMessageContainer?.borderRadius || "12px"};
      height: 100%;
      background-color: ${chatMessagesContainer?.backgroundColor || "#F5F5F5"};
      border-bottom-right-radius: ${chatBotMessageContainer?.borderRadius || "12px"};
    }

    .react-chatbot-kit-user-chat-message-container .inner {
      background-color:  ${chatUserMessageContainer?.backgroundColor || "#EBEBEB"};
      border-radius: ${chatUserMessageContainer?.borderRadius || "12px"};
      padding: ${chatUserMessageContainer?.padding || chatMessageContainer?.padding || "8px"};
    }

    .react-chatbot-kit-user-chat-message-container .quote-tail {
      width: ${chatBotMessageContainer?.borderRadius};
      background-color: ${chatBotMessageContainer?.backgroundColor || "#FFFFFF"};
      border-radius: ${chatBotMessageContainer?.borderRadius || "12px"};
    }

    .react-chatbot-kit-user-chat-message-container .quote-tail > div {
      width: ${chatBotMessageContainer?.borderRadius || "12px"};
      height: 100%;
      background-color: ${chatMessagesContainer?.backgroundColor || "#F5F5F5"};
      border-bottom-left-radius: ${chatBotMessageContainer?.borderRadius || "12px"};
    }

    .react-chatbot-kit-chat-bot-form-container .message-title,
    .react-chatbot-kit-chat-bot-message-container .message-title,
    .react-chatbot-kit-user-chat-message-container .message-title {
      font-size: ${chatMessageTitle?.fontSize || "10px"};
      font-weight: ${chatMessageTitle?.fontWeight || "700"};
      line-height: ${chatMessageTitle?.lineHeight || "10px"};
      color: ${chatMessageTitle?.color || "rgba(0, 0, 0, 0.82)"};
      padding-bottom: 4px;
    }
      
    .react-chatbot-kit-chat-bot-form-container .message-title,
    .react-chatbot-kit-chat-bot-message-container .message-title {
      color: ${chatBotMessageTitle?.color || chatMessageTitle?.color || "rgba(0, 0, 0, 0.82)"};
    }

    .react-chatbot-kit-user-chat-message-container .message-title {
      color: ${chatUserMessageTitle?.color || chatMessageTitle?.color || "rgba(0, 0, 0, 0.82)"};
    }

    .react-chatbot-kit-chat-bot-form-container .message-text,
    .react-chatbot-kit-chat-bot-message-container .message-text,
    .react-chatbot-kit-user-chat-message-container .message-text {
      font-size: ${chatMessageText?.fontSize || "18px"};
      line-height: ${chatMessageText?.lineHeight || "18px"};
      color: ${chatMessageText?.color || "rgba(0, 0, 0, 0.6)"};
      padding:${chatMessageText?.padding || "8px 10px 10px 8px"};
      word-wrap: break-word;
    }

    .react-chatbot-kit-chat-bot-form-container .message-text,
    .react-chatbot-kit-chat-bot-message-container .message-text{
      color: ${chatBotMessageText?.color || chatMessageText?.color || "rgba(0, 0, 0, 0.6)"};
      word-wrap: break-word;
    }

    .react-chatbot-kit-user-chat-message-container .message-text {
      color: ${chatUserMessageText?.color || chatMessageText?.color || "rgba(0, 0, 0, 0.6)"};
      word-wrap: break-word;
    }

    /* Footer message input */
    .react-chatbot-kit-chat-input-container {
      display: ${ !!viewMode ? "none" : "block"};
      position: relative;
      padding: ${chatUserInputContainer?.padding || "20px 16px 20px 16px"};
      background-color: ${chatUserInputContainer?.backgroundColor || "#F5F5F5"};
    }

    .react-chatbot-kit-chat-input {
      border:  ${chatUserInputField?.border || "none"};
      margin-right:  ${chatUserInputField?.marginRight || "8px"};
      box-shadow: ${chatUserInputField?.boxShadow || "0px 1px 2px rgba(0, 0, 0, 0.08)"};
      border-radius: ${chatUserInputField?.borderRadius || "12px 12px 0px 12px"};
      font-size: ${chatUserInputField?.fontSize || "18px"};
      font-weight: ${chatUserInputField?.fontWeight || "400"};
      line-height: ${chatUserInputField?.lineHeight || "100% "};
      color: ${chatUserInputField?.color || "#000000"};
      padding: ${chatUserInputField?.padding || "19px 20px"};
      background-color: ${chatUserInputField?.backgroundColor || "transparent"};
      outline: none;
    }
    .react-chatbot-kit-chat-input:focus,
    .react-chatbot-kit-chat-input:focus-visible {
      border:  ${chatUserInputFieldFocused?.border || chatUserInputField?.border || "none"};
      outline: none;
    }
    .react-chatbot-kit-chat-input::placeholder{
      font-size: ${chatUserInputPlaceholder?.fontSize || "18px"};
      color: ${chatUserInputPlaceholder?.color || "#A2ACB4"};
      font-weight: ${chatUserInputPlaceholder?.fontWeight || "400"};
      line-height: ${chatUserInputPlaceholder?.lineHeight || "100%"};
    }

    .react-chatbot-kit-chat-btn-send {
      display: flex;
      justify-content: center;
      align-items: center;

      min-width: ${chatSendButton?.width || "56px"};
      min-height: ${chatSendButton?.height || "56px"};
      max-width: ${chatSendButton?.width || "56px"};
      max-height: ${chatSendButton?.height || "56px"};
      width: ${chatSendButton?.width || "56px"};
      height: ${chatSendButton?.height || "56px"};

      border-radius: ${chatSendButton?.borderRadius || "56px"};
      background-color: ${chatSendButton?.backgroundColor || "#9C27B0"};

      box-shadow: ${chatSendButton?.boxShadow || "none"};
    }

    ${chatSendButtonIcon?.backgroundImage &&
      prepareSubmitButtonIcon(chatSendButtonIcon)
    }

    /*  */
    .react-chatbot-kit-chat-inner-container .chat-form-container {
      background-color: ${chatFormContainer?.backgroundColor || "#FFFFFF"};
      border-radius: 12px;
    }

    .react-chatbot-kit-chat-inner-container .chat-form-title {
    
    }

    .react-chatbot-kit-chat-inner-container .chat-form {
      margin-top: 10px;
    }

    .react-chatbot-kit-chat-inner-container .chat-form-item {
      margin-bottom: 8px;
    }

    .react-chatbot-kit-chat-inner-container .chat-form-item:last-child {
      margin-bottom: 0 ;
    }

    .react-chatbot-kit-chat-inner-container .chat-form-label {
      font-size: ${chatFormLabel?.fontSize || "12px"};
      font-weight: ${chatFormLabel?.fontWeight || "500"};
      line-height: ${chatFormLabel?.lineHeight || "12px"};
      color: ${chatFormLabel?.color || "#999999"};
      margin-bottom: 5px;
    }

    .react-chatbot-kit-chat-inner-container .chat-form .input-field {
      width: 100%;
      min-height: ${chatFormInputField?.height || "20px"};
      border: 1px solid ${chatFormInputField?.borderColor || "#DBDCDF "};
      border-radius: ${chatFormInputField?.borderRadius || "6px"};
      padding: ${chatFormInputField?.padding || "8px 10px"};
      color: ${chatFormInputField?.color || "inherit"};
      background-color: ${chatFormInputField?.backgroundColor || "inherit"};
      outline: none;
    }

    .react-chatbot-kit-chat-inner-container .chat-form .input-field:focus,
    .react-chatbot-kit-chat-inner-container .chat-form .input-field:focus-visible {
      border: 1px solid ${chatFormInputFieldFocused?.borderColor || "transparent"};
      outline: none;
    }

    .react-chatbot-kit-chat-inner-container .chat-form select {
      min-width: 200px;
      border: 1px solid ${chatFormSelect?.borderColor || "#e5e7eb "};
      width: 100%;
      border-radius: ${chatFormSelect?.borderRadius || "6px"};
      flex-shrink: 1;
      padding: ${chatFormSelect?.padding || "8px 10px"};
      color: ${chatFormSelect?.color || "inherit"};
      background-color: ${chatFormSelect?.backgroundColor || "inherit"};
    }

    .react-chatbot-kit-chat-inner-container .chat-form select:focus,
    .react-chatbot-kit-chat-inner-container .chat-form select:focus-visible {
      outline: none;
    }

    .react-chatbot-kit-chat-inner-container .chat-form .radio-buttons-block {
      padding: ${chatFormRadioButtonsBlock?.padding || "5px"};
      border-radius: ${chatFormRadioButtonsBlock?.borderRadius || "20px"};
      background-color: ${chatFormRadioButtonsBlock?.backgroundColor || "inherit"};
    }
    .react-chatbot-kit-chat-inner-container .chat-form .radiobutton-field {
      line-height: 20px;
      margin-bottom: 8px;
    }

    .react-chatbot-kit-chat-inner-container .chat-form .radiobutton-field:last-child {
      margin-bottom: 0;
    }

    .react-chatbot-kit-chat-inner-container label.select-button .radiobutton,
    .react-chatbot-kit-chat-inner-container .chat-form .radiobutton-field .radiobutton {
      border: ${chatFormRadioButton?.border || "1px solid"};
      height: ${chatFormRadioButton?.width || "20px"};
      width: ${chatFormRadioButton?.height || "20px"};
      max-height: ${chatFormRadioButton?.width || "20px"};
      max-width: ${chatFormRadioButton?.height || "20px"};
      border-radius: ${chatFormRadioButton?.borderRadius || "20px"};
      background-color: ${chatFormRadioButton?.backgroundColor || "inherit"};
    }

    .react-chatbot-kit-chat-inner-container label.select-button input:checked + .radiobutton, 
    .react-chatbot-kit-chat-inner-container .chat-form .radiobutton-field input:checked + .radiobutton {
      border: ${chatFormRadioButtonSelected?.border || "1px solid"};
      height: ${chatFormRadioButtonSelected?.width || "20px"};
      width: ${chatFormRadioButtonSelected?.height || "20px"};
      max-height: ${chatFormRadioButtonSelected?.width || "20px"};
      max-width: ${chatFormRadioButtonSelected?.height || "20px"};
      border-radius: ${chatFormRadioButtonSelected?.borderRadius || "20px"};
      background-color: #0379C2 !important;
      border-color: #4361EE !important;
    }

    .react-chatbot-kit-chat-inner-container .chat-form .radiobutton-name {
      font-size: ${chatFormRadioButtonLabel?.fontSize || "14px"};
      color: ${chatFormRadioButtonLabel?.color || "#0E1726"};
      padding-bottom: 1px;
    }

    .react-chatbot-kit-chat-inner-container .select-buttons {
      display: flex;
    }

    .react-chatbot-kit-chat-inner-container label.select-button {
      width: 100%;
      margin-right: 8px;

      padding: 8px;
      border: 1px solid ${selectButton?.borderColor || "#4361EE"};
      border-radius: 6px;

      font-size: ${selectButton?.fontSize || "14px"};
      font-weight: ${selectButton?.fontWeight || "500"};
      line-height: ${selectButton?.lineHeight || "20px"};
      color: ${selectButton?.color || "#4361EE"};
      margin-bottom: 0 !important;
      cursor: pointer;
    }

    .react-chatbot-kit-chat-inner-container label.select-button:last-child {
      margin-right: 0;
    }

    .react-chatbot-kit-chat-inner-container .select-button .label {
      width: 100%;
      text-align: center;
      margin-bottom: 0 !important;
    }

    .submit-button {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      padding: ${chatFormSubmitButton?.padding || "8px"};
      margin-top: 4px;
      border: 1px solid ${chatFormSubmitButton?.borderColor || "#4361EE"};
      border-radius: ${chatFormSubmitButton?.borderRadius || "6px"};

      font-size: ${chatFormSubmitButton?.fontSize || "14px"};
      font-weight: ${chatFormSubmitButton?.fontWeight || "500"};
      line-height: ${chatFormSubmitButton?.lineHeight || "20px"};
      color: ${chatFormSubmitButton?.color || "#4361EE"};
      background-color: ${chatFormSubmitButton?.backgroundColor || "transparent"};
      box-shadow: ${chatFormSubmitButton?.boxShadow || "none"};
    }

    .submit-button:disabled {
      color: ${chatFormSubmitButtonDisabled?.color || "rgba(136, 142, 168, 1)"};
      background-color: ${chatFormSubmitButtonDisabled?.backgroundColor || "rgba(14, 23, 38, 0.04)"};
      border: 1px solid ${chatFormSubmitButtonDisabled?.borderColor || "rgba(136, 142, 168, 1)"};
      box-shadow: ${chatFormSubmitButtonDisabled?.boxShadow || "none"};
    }

    footer {
      padding: 0 !important;
    }

    @media (width <= 800px) {
      .react-chatbot-kit-chat-bot-form-container,
      .react-chatbot-kit-chat-bot-message-container {
        padding-right: 16px;
      }

      .react-chatbot-kit-user-chat-message-container {
        padding-left: 16px;
      }

      .react-chatbot-kit-chat-bot-form-container .inner,
      .react-chatbot-kit-chat-bot-message-container .inner,
      .react-chatbot-kit-user-chat-message-container .inner {
        position: relative;
        width: 100%;
        max-width: 100%;
        padding: 8px;
      }
    }

  `
}

const prepareSubmitButtonIcon = (chatSendButtonIcon: any) => {
  return `
    .react-chatbot-kit-chat-btn-send::before {
      display: flex;
      justify-content: center;
      align-items: center;
      content: '';
      width: ${chatSendButtonIcon?.width || "20px"};
      height: ${chatSendButtonIcon?.height || "20px"};
      min-width: ${chatSendButtonIcon?.width || "20px"};
      min-height: ${chatSendButtonIcon?.height || "20px"};
      margin: ${chatSendButtonIcon?.margin || "0 58px"};
      background: ${chatSendButtonIcon?.backgroundImage || "red"};
    }

    .react-chatbot-kit-chat-btn-send-icon {
      width: 0px;
      height: 0px;
    }
  `
}

export default generateCustomStyles;
